import { Table } from 'antd';
import { ColumnType } from 'antd/lib/table';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TableSort from '../../../../components/TableSort';
import { ApplicationState } from '../../../../store';
import { Sorter } from '../../../../utils/sorte';
import { EstoqueDetalhesService } from '../../services/estoqueServices';
import ModalSolicitarRetorno from '../Modal/ModalSolicitarRetorno';
import { EstoqueProps } from './props';
import { TableStyle } from './styles';
import moment from 'moment';

const TableSec: React.FC<EstoqueProps> = ({ record }) => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const filtro = useSelector((state: ApplicationState) => state.Estoque.filter);
  const [control, setControl] = useState(false);
  const [controller, setController] = useState(false);
  const [response, setResponse] = useState<any>([]);

  useEffect(() => {
    let abortController = new AbortController();
    if (controller === false) {
      setControl(true);
      try {
        EstoqueDetalhesService.getDetalheEstoque(
          record.codParceiro,
          cddAtivo?.codCdd,
          record.codProduto,
          filtro
        ).then((res) => {

          setResponse(res?.data?.estoques);
          if (res?.data.estoques) setControl(false);
        });
      } finally {
        setController(true);
      }
    }
    return () => {
      abortController.abort();
    };
  }, [controller, record, control, inscricaoAtiva, cddAtivo?.codCdd, filtro]);

  const resulta = response?.map((itemEstoq: any) => ({
    ...itemEstoq,
    diasParaVencer:
      itemEstoq.diasParaVencer < 0
        ? `${0} Dias`
        : itemEstoq.diasParaVencer
          ? itemEstoq.diasParaVencer + ' Dias'
          : '',
    pagador: itemEstoq.pagador === null ? 'PAGADOR NÃO IDENTIFICADO' : itemEstoq.pagador,
    qtdPadraoFracionado: !itemEstoq.qtdPadraoFracionado ? 0 : itemEstoq.qtdPadraoFracionado,
  }));

  const getDetails = resulta?.find((respo: any) => respo.qtdPadraoFracionado);

  const columnsModal: ColumnType<any>[] = [
    {
      title: 'Solicitação',
      key: 'operation',

      render: (text: any, record: any) => {

        return (
          <>
            <ModalSolicitarRetorno
              text={text}
              record={record}
              detalhesEstoque={getDetails?.qtdPadraoFracionado}
              lote={record.controle}
              numeroNota={getDetails?.nuNota}
            />
          </>
        )
      },
    },
    {
      title: 'Número da nota',
      dataIndex: 'numNota',
      key: 'numNota ',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
    },
    {
      title: 'Lote',
      dataIndex: 'controle',
      key: 'controle',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 2,
      },
    },
    {
      title: 'Tempo restante',
      dataIndex: 'diasParaVencer',
      key: 'diasParaVencer',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
    },
    {
      title: 'Data validade',
      dataIndex: 'dtValidade',
      key: 'dtValidade',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },

      render: (text) => {
        return text ? moment(text).format('LL') : 'Não informado';
      },
    },
    {
      title: 'Pagador',
      dataIndex: 'pagador',
      key: 'pagador',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
    },
    {
      title: 'Coberto',
      dataIndex: 'cobertura',
      key: 'cobertura',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 6,
      },
      render(text) {
        return text ? 'Sim' : 'Não';
      },
    },

    {
      title: 'Disponível',
      dataIndex: 'disponivel',
      key: 'disponivel',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 7,
      },
      render(text, record) {
        return <span>{text}</span>;
      },
    },
    {
      title: 'Reservado',
      dataIndex: 'reservado',
      key: 'reservado',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 8,
      },
      render(text, record) {
        let textColor = text > 0 ? '#D48806' : '#595959';
        return <span style={{ color: `${textColor}` }}>{text}</span>;
      },
    },
    {
      title: 'Indisponível',
      dataIndex: 'indisponivel',
      key: 'indisponivel',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 9,
      },
      render(text, record) {
        let textColor = text > 0 ? '#CF1322' : '#595959';
        return <span style={{ color: `${textColor}` }}>{text}</span>;
      },
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 10,
      },
      render(text, record) {
        return <span>{text}</span>;
      },
    },
  ];

  return (
    <>
      <TableStyle>
        <TableSort
          columns={columnsModal}
          size={'middle'}
          rowKey="numNota"
          style={{ border: '2px solid' }}
          scroll={{ x: 1450 }}
          dataSource={resulta}
          loading={control === true ? true : false}
          pagination={false}
          summary={(pageData: any) => {
            let totalDiponivel = 0;
            let totalIndisponivel = 0;
            let totalReservado = 0;
            let totalGeral = 0;
            pageData.forEach(({ disponivel, indisponivel, reservado, total }: any) => {
              totalDiponivel += disponivel || 0;
              totalIndisponivel += indisponivel || 0;
              totalReservado += reservado || 0;
              totalGeral += total || 0;
            });

            return (
              <>
                <Table.Summary.Row className="tableSubTotal">
                  <Table.Summary.Cell index={0} colSpan={7}>
                    <strong>SUBTOTAL</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <strong>{totalDiponivel}</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2}>
                    <strong>{totalReservado}</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3}>
                    <strong>{totalIndisponivel}</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4}>
                    <strong>{totalGeral}</strong>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </TableStyle>
    </>
  );
};

export default TableSec;
